import { render, staticRenderFns } from "./userDashboardTerminationDialog.vue?vue&type=template&id=56cf4cc9"
import script from "./userDashboardTerminationDialog.vue?vue&type=script&lang=js"
export * from "./userDashboardTerminationDialog.vue?vue&type=script&lang=js"
import style0 from "./userDashboardTerminationDialog.vue?vue&type=style&index=0&id=56cf4cc9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports